import { observer } from 'mobx-react-lite'
import { MergeFieldsIconAction } from 'widgets/MergeField/ui/actions/MergeFieldsIconAction/MergeFieldsIconAction'
import { useTextToSpeechContext } from 'widgets/TextToSpeech/context/context'

export const MergeFieldBtn = observer(() => {
  const { textToSpeechTextStore } = useTextToSpeechContext()
  return (
    <MergeFieldsIconAction
      onAddMergeField={(value) => textToSpeechTextStore.handleMergeField(value)}
      isSelectDefault
      useAllMergeFields
      sizeTriggerButton={'small'}
    />
  )
})
